import { SeriesColumnsContentDirective } from '../components/reportobjectmenus/chart/series.menu.control';
import { DynamicTimeSettingsService } from '../services/dynamictimesettings.service';
import { MacNavigationService } from '../services/navigation.service';
import { PlanningService } from '../services/planning.service';
import { RelSourceService } from '../services/relSource.service';
import { MultiReportingService, ReportingService } from '../services/reporting.service';

export const MAC_SERVICES = [
    RelSourceService,
    ReportingService,
    DynamicTimeSettingsService,
    MacNavigationService,
    MultiReportingService,
    PlanningService
];

export const MAC_DIRECTIVES = [
    SeriesColumnsContentDirective
];
